import * as React from 'react';
import { Button, ModalWindow, UIHeading2, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

import * as styles from './SuccessModalWindow.css';

export interface ISuccessModalWindowProps {
  onClose: () => void;
  open: boolean;
}

export const SuccessModalWindow: React.FC<ISuccessModalWindowProps> = ({ onClose, open }) => {
  const deviceType = useDeviceType();

  const isPhone = deviceType === 'phone';
  const height = isPhone ? '100%' : undefined;

  const UIText = isPhone ? UIText2 : UIText1;

  return (
    <ModalWindow
      escape
      footer={
        <div className={styles['button-wrapper']}>
          <Button onClick={onClose} fullWidth={isPhone} data-testid="ThanksButton">
            Спасибо, жду
          </Button>
        </div>
      }
      height={height}
      onClose={onClose}
      open={open}
      outside
      print
      size="M"
      width={688}
    >
      <div className={styles['success-modal-content-wrapper']} data-testid="SuccessModalWindowContent">
        <div className={styles['success-modal-content']}>
          <div className={styles['image']} />
          <div className={styles['title']}>
            <UIHeading2 textAlign="center">Начали искать, скоро перезвоним</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText>
              Консультант перезвонит в течение пары часов, задаст уточняющие вопросы и предложит
              подходящие&nbsp;варианты
            </UIText>
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};
